import{jsx as d}from"react/jsx-runtime";import i from"styled-components";import a from"../../theme.js";const p=i.button`
  width: 46px;
  height: 24px;
  border-radius: 12px;
  border: none;
  padding: 2px;
  background-color: ${({$selected:o,disabled:e,$color:l,$colorShade:r})=>e?a.colors.grayscaleToned.light4:o?a.colors[l][r]:a.colors.grayscaleToned.dark5};
  display: flex;
  align-items: center;
  justify-content: ${({$selected:o})=>o?"flex-end":"flex-start"};
  cursor: ${({disabled:o})=>o?"not-allowed":"pointer"};
  opacity: ${({disabled:o})=>o?.6:1};
  transition: all 0.3s ease;
`,b=i.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({disabled:o})=>o?a.colors.grayscaleToned.light6:a.colors.common.white};
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.09),
    0 1px 5px rgba(0, 0, 0, 0.15);
`,s=({selected:o=!1,disabled:e=!1,onToggle:l,color:r="info",colorShade:c="mainAlt",ariaLabel:t,...n})=>d(p,{role:"switch","aria-checked":o,"aria-disabled":e,"aria-label":t??"Toggle",disabled:e,$selected:o,$color:r,$colorShade:c,onClick:()=>{!e&&l&&l(!o)},...n,children:d(b,{disabled:e})});export{s as Switcher,s as default};
